import PropTypes from 'prop-types';

const profileType = PropTypes.shape({
  email: PropTypes.string,
  fullName: PropTypes.string,
  id: PropTypes.string.isRequired,
});

const archetypeType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  percentage: PropTypes.number.isRequired,
});

const profileWithArchetypeType = PropTypes.shape({
  profile: profileType,
  archetype: archetypeType,
});

export default profileWithArchetypeType;
